import WorkspaceTable from "./workspace-table";

export default WorkspaceTable;
